import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { AuthService } from '@services/security';

@Injectable({ providedIn: 'root' })
export class PatientsService {
    constructor(private http: HttpClient, private authService: AuthService) {}

    getPatients(fields) {
        return this.http.get(`${environment.apiUrl}/simple-patients`, {
            params: { ...fields },
        });
    }

    getCompanyAllPatients(fields) {
        return this.http.get(`${environment.apiUrl}/company/all-patients`, {
            params: { ...fields },
        });
    }

    updateMultiPatientSpecialist(body) {
        return this.http.put(`${environment.apiUrl}/multipatient/specialist`, body);
    }

    updateMultiPatientCarestaff(body) {
        return this.http.put(`${environment.apiUrl}/multipatient/carestaff`, body);
    }

    updateMultiPatientExtern(body) {
        return this.http.put(`${environment.apiUrl}/multipatient/extern`, body);
    }

    getFollowedPatients(path, data) {
        return this.http.get(`${environment.apiUrl}/${path}`, { params: data });
    }

    countFollowedPatients(data) {
        return this.http.get(`${environment.apiUrl}/admin-follow/count`, {
            params: data,
        });
    }

    treatPatient(path, patientId) {
        return this.http.put(`${environment.apiUrl}/${path}/${patientId}`, {});
    }

    cancelWaitingSepa(patientId: string) {
        return this.http.delete(`${environment.apiUrl}/patients-waiting-sepa/${patientId}`);
    }

    treatComments(path, commentId) {
        return this.http.put(`${environment.apiUrl}/${path}`, { commentId });
    }

    processDocuments(path, logId) {
        return this.http.put(`${environment.apiUrl}/${path}`, { logId });
    }

    processNewBio(path, logId) {
        return this.http.put(`${environment.apiUrl}/${path}`, { logId });
    }

    processRejectedBio(path, logId) {
        return this.http.put(`${environment.apiUrl}/${path}`, { logId });
    }

    getFollowedPatientsByDocID(fields) {
        return this.http.get(`${environment.apiUrl}/followed-patients`, {
            params: fields,
        });
    }

    searchPatientsDashboard(search) {
        return this.http.get<any>(`${environment.apiUrl}/dashboard/search-patients`, {
            params: {
                search,
                isFiltersRegionsEnabled: this.authService.isFilterRegionsEnabled(),
            },
        });
    }
}
